import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ExcessContributionWithdrawPayload } from './useExcessContributionWithdraw.query';

const GET_EXCESS_CONTRIBUTION_QUERY_KEY = 'GET_EXCESS_CONTRIBUTION_QUERY_KEY';

export interface ExcessContributionWithdraw {
  employeeId?: string;
  accountId?: string;
  amount?: string;
  excessEarnings?: string;
  paymentMethodId?: string;
  fileUrl?: string;
}

const useGetExcessContributionQuery = (id?: string, enabled: boolean = true) => {
  const { data, isLoading } = useQuery(
    [GET_EXCESS_CONTRIBUTION_QUERY_KEY, id, enabled],
    // TODO: the type is missing
    () => api.get<ExcessContributionWithdrawPayload>(API_URL.TAX_FORMS_EXCESS_CONTRIBUTIONS_BY_ID(id || '')),
    {
      enabled: Boolean(enabled && id),
    }
  );
  const excessContribution = useMemo(() => {
    if (!data?.data) return;

    return {
      employeeId: toString(data?.data?.employee_id),
      accountId: toString(data?.data?.account_id),
      amount: toString(data?.data?.amount),
      excessEarnings: toString(data?.data?.excess_earnings),
      paymentMethodId: toString(data?.data?.payment_method_id),
      fileUrl: data?.data?.file_url,
    } as ExcessContributionWithdraw;
  }, [data]);

  return {
    excessContribution,
    isLoading,
  };
};

export default useGetExcessContributionQuery;
